// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const analytics = getAnalytics(app);

// Lazy load Firestore with memory-only cache to avoid IndexedDB connection issues
// Use promise-based singleton to prevent race conditions with concurrent initialization
let firestorePromise: Promise<any> | null = null;

export const getFirestoreDb = async () => {
  if (!firestorePromise) {
    firestorePromise = (async () => {
      const { initializeFirestore, memoryLocalCache } = await import(
        "firebase/firestore"
      );
      return initializeFirestore(app, {
        localCache: memoryLocalCache(),
      });
    })();
  }
  return firestorePromise;
};

export const functions = getFunctions(app);

export const storage = getStorage(app);

// Lazy load Firestore query functions
export const getFirestoreQueryFunctions = async () => {
  const { query, collection, onSnapshot, where, addDoc } = await import(
    "firebase/firestore"
  );
  return { query, collection, onSnapshot, where, addDoc };
};
